const text = {
  ABOUT: "about.md",
  SITE: "site.md",
  SIDEBAR: "sidebar.md",
};

const js = {
  POSITIONS: "resume/positions",
};

const TEMPLATES = {
  JS_FILES: js,
  TEXTS_FILES: text,
};

export default TEMPLATES;
